module.exports = __webpack_public_path__ + "954c24bb4bbfe909730f85f6c55c8e9e.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/twg.svg
// module id = 416
// module chunks = 0